import { getBusClassesOfPlatformBusClasses, platformBusClassesByBusClass } from '@lib/shared';

import { BusClass, PlatformBusClass } from '~/apiClient';

export const getPlatformBusClassesFromBusClass = (busClass: BusClass): PlatformBusClass[] =>
    platformBusClassesByBusClass[busClass].map(platformBusClass => PlatformBusClass[platformBusClass]);

export const getMainPlatformBusClassFromBusClass = (busClass: BusClass): PlatformBusClass => getPlatformBusClassesFromBusClass(busClass)[0];

export const getBusClassesFromPlatformBusClasses = (platformBusClasses: PlatformBusClass[]): BusClass[] =>
    getBusClassesOfPlatformBusClasses(platformBusClasses).map(busClass => BusClass[busClass]);

export const getBusClassesFromPlatformBusClass = (platformBusClass: PlatformBusClass): BusClass[] =>
    getBusClassesFromPlatformBusClasses([platformBusClass]);
